
const routes = [
    {
        path: '/',
        component: () => import('src/layouts/MainLayout.vue'),
        children: [
            {
                path: '',
                component: () => import('pages/home/Home.vue'),
                children: [
                    {
                        path: '',
                        name: 'home',
                        component: () => import('pages/home/TableView.vue'),
                    },
                    {
                        path: 'map',
                        name: 'map',
                        component: () => import('pages/home/MapView.vue'),
                    },
                ],
            },
            {
                name: 'plan_details',
                path: 'plans/:planSlug',
                component: () => import('pages/plan/form/PlanDetails.vue'),
                props: true,
            },

            {
                name: 'plan_invoice_request',
                path: 'invoice-requests/:invoiceRequestId',
                component: () => import('pages/plan/invoiceRequest/InvoiceRequest.vue'),
                props: true,
            },

            {
                name: 'plan_access_request',
                path: 'plans/:planSlug/access-requests/:accessRequestUuid/:decision',
                component: () => import('pages/plan/AccessRequest.vue'),
                props: true,
            },

            {
                name: 'mpr',
                path: 'monthly-project-reviews/:mprId',
                component: () => import('pages/mpr/layout/MonthlyProjectReviewLayout.vue'),
                props: true,
            },

            {
                name: 'change_history',
                path: 'plans/:planSlug/history',
                component: () => import('pages/changeHistory/ChangeHistory.vue'),
                props: true,
            },

            {
                name: 'mpr_overview',
                path: 'mprs/overview',
                component: () => import('pages/mprOverview/MprOverview.vue'),
            },

            {
                name: 'mpr_snapshot_overview',
                path: 'mpr-snapshots/overview',
                component: () => import('pages/mprSnapshotOverview/MprSnapshotOverview.vue'),
            },
            {
                name: 'global_kpi_overview',
                path: 'kpi/overview',
                component: () => import('pages/kpiOverview/KpiOverview.vue'),
            },

            {
                name: 'global_kpi_overview',
                path: 'kpi/overview',
                component: () => import('pages/kpiOverview/KpiOverview.vue'),
            },

            {
                name: 'budget_update_overview',
                path: 'budget-updates/overview',
                component: () => import('pages/budgetUpdateOverview/BudgetUpdateOverview.vue'),
            },

            {
                name: 'invoice_request_overview',
                path: 'invoice-request/overview',
                component: () => import('pages/invoiceRequestOverview/InvoiceRequestOverview.vue'),
            },

            {
                name: 'tasks',
                path: 'tasks',
                component: () => import('pages/tasks/Tasks.vue'),
                props: true,
            },

            {
                name: 'budget_updates',
                path: 'budget-updates/:budgetUpdateId',
                component: () => import('pages/budgetUpdate/BudgetUpdate.vue'),
                props: true,
            },

            /////////////////////
            // User Management //
            /////////////////////

            {
                name: 'users',
                path: 'users',
                component: () => import('pages/users/Users.vue'),
            },
            {
                name: 'data-source-regions',
                path: 'data-source-regions',
                component: () => import('pages/dataSourceRegions/DataSourceRegions.vue'),
            },
        ],
    },

    {
        path: '/:catchAll(.*)*',
        redirect: '/',
    },
]

export default routes
